import { Box, Grid, Typography } from "@mui/material"
import { IMyDataSidebarItem } from "../MyData";
import { useEffect, useState } from "react";

export interface ISidebarUserMenuOptions {
    selectedOption: number;
    sideBarOptionList: IMyDataSidebarItem[];
    setIndex: (set: number) => void;
}

export const SidebarUserMenuOptions: React.FC<ISidebarUserMenuOptions> = ({
    selectedOption,
    sideBarOptionList,
    setIndex
}) => {

    useEffect(() => {
        setIndex(selectedOption);
    }, [selectedOption])

    return (
        <Grid 
            item 
            xs={2}
            borderRight="1px solid rgba(34, 99, 141, 0.10)"
        >
            { sideBarOptionList.map((el, index) => (
                <Box
                    display="flex"
                    height="36px"
                    marginBottom="4px"
                    alignItems="center"
                    padding="10px"
                    width="80%"
                    sx={{
                        cursor: "pointer",
                        ":hover": {
                            background: "#22638D1A",
                            color: "#22638D",
                            borderRadius: "4px"
                        }
                    }}
                    style={selectedOption == sideBarOptionList[index].id ? {
                        background: "#22638D1A",
                        color: "#22638D",
                        borderRadius: "4px"
                    } : {}}
                    onClick={el.onClick}
                >
                    { el.icon }
                    <Typography
                        fontSize="14px"
                    >
                        { el.text }
                    </Typography>
                </Box>
            )) }
        </Grid>
    )
}